function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapFilterAll = function SvgLivemapFilterAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 37.998,
    viewBox: "0 0 38 37.998"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Path 12018",
    style: {
      fill: "none"
    },
    transform: "translate(7.572 8.234)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.271-10278.213h.005a22.965 22.965 0 0 1-2.372-2.719c-1.483-2.008-2.236-3.772-2.236-5.254a4.77 4.77 0 0 1 4.869-4.646 4.77 4.77 0 0 1 4.864 4.646c0 3.546-4.419 7.8-4.6 7.973a.374.374 0 0 1-.258.106h-.009a.365.365 0 0 1-.263-.106zm-3.859-7.973a8.216 8.216 0 0 0 1.765 4.357 23.421 23.421 0 0 0 2.36 2.843 22.715 22.715 0 0 0 2.354-2.843 8.193 8.193 0 0 0 1.763-4.357 4.034 4.034 0 0 0-4.117-3.931h-.091a4.038 4.038 0 0 0-4.034 3.931zm-10.3 4.838v-13.845l6.334-2.411 5.624 2.249 6.332-2.411v7.053a5.512 5.512 0 0 0-.853-.615v-5.2l-5.055 1.921v2.891l-.85.306v-3.2l-4.773-1.908v12.021l2.331.932c.152.391.31.76.468 1.1l-3.23-1.292-6.324 2.408zm.853-13.258v12.025l5.055-1.926v-12.028zm13.625 11.01h-.062a2.577 2.577 0 0 1-1.786-.829 2.562 2.562 0 0 1-.687-1.84 2.574 2.574 0 0 1 .788-1.786 2.594 2.594 0 0 1 1.845-.731 2.579 2.579 0 0 1 1.809.778 2.566 2.566 0 0 1 .744 1.821 2.611 2.611 0 0 1-.8 1.838 2.613 2.613 0 0 1-1.831.752zm.036-.719h.026a1.882 1.882 0 0 0 1.845-1.873 1.915 1.915 0 0 0-1.92-1.877h-.041a1.891 1.891 0 0 0-1.786 1.938 1.869 1.869 0 0 0 1.877 1.813z",
    "data-name": "Union 8",
    style: {
      fill: "#4da5b5",
      stroke: "#4da5b5",
      strokeLinejoin: "bevel",
      strokeWidth: ".8px"
    },
    transform: "translate(168 10307.828)"
  })));
};
export default SvgLivemapFilterAll;